import grispiApi from '../../apis/grispiApi';
import { CurrentAgentStatus } from '../../model/types';
import { getCurrentUserEmail } from '../../utils/accountHelper';
import { fetcherWithToken } from '../../utils/fetchers';

export const getAgentCurrentStatus = async (username: string): Promise<CurrentAgentStatus> => {
    if (!username) return;
    const currentStatus = await fetcherWithToken(`/users/${username}/status/current`);

    return currentStatus;
};

export const setAgentCurrentStatus = async (statusId: number): Promise<any> => {
    const username = getCurrentUserEmail();

    await grispiApi.post(`/users/${username}/status`, { id: statusId });
};
